module.exports = __webpack_public_path__ + "img/Artboard – 7.9206a7d7.png";